export const JourneyItem = ({
  title,
  emoji,
  tagline,
}: {
  title: string
  emoji: string
  tagline: string
}) => (
  <div className='flex flex-col items-start'>
    <h3 className='text-lg font-bold text-[#101828] leading-6 tracking-[0.4px] lg:text-3xl 3xl:text-[64px] 3xl:leading-[0.8]'>
      {title} <span className='inline-block'>{emoji}</span>
    </h3>
    <h5 className='text-sm font-normal text-[#101828] lg:text-xl 3xl:text-[40px] 3xl:leading-relaxed xl:mb-1 tracking-[0.4px]'>{tagline}</h5>
  </div>
)